import "./application_shared"

import "stylesheet/mymatrimony"
